export default "__VITE_ASSET__GYUPoV95__"